import React, { Component, PureComponent, Fragment } from 'react'
import { Group } from '~/form'
import { Button, Table, Message, Icon } from 'semantic-ui-react'

let inputs = [
  {
    type: 'text',
    placeholder: 'Nimi',
  },
  {
    type: 'email',
    placeholder: 'Sähköposti',
  },
  {
    type: 'text',
    placeholder: 'Puhelinnumero',
  },
  {
    type: 'text',
    placeholder: 'Muistiinpanot',
  },
  {
    type: 'select',
    options: {
      fi: 'FI',
      en: 'EN',
      se: 'SE',
    },
    placeholder: 'Kieli',
  },
]

export default class PeopleAddFromInputs extends Component {
  changeValue = (rowKey, inputKey, value) => {
    let { onChange, values } = this.props

    let row = values[rowKey] || []
    row[inputKey] = value
    values[rowKey] = row
    onChange(values)
  }

  addRows = (count = 1) => {
    let { onChange, values } = this.props

    while (count) {
      values.push({})
      count--
    }

    onChange(values)
  }

  removeRow = rowKey => {
    let { onChange, values } = this.props
    values.splice(rowKey, 1)
    onChange(values)
  }

  render() {
    let { values, onChange, rowErrors } = this.props

    return (
      <div className="ui form">
        <Group title="Henkilöt">
          <Table compact className="form-table">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell content="Nimi" />
                <Table.HeaderCell content="Sähköposti" />
                <Table.HeaderCell content="Puhelinnumero" />
                <Table.HeaderCell content="Muistiinpanot" />
                <Table.HeaderCell content="Kieli" />
                <Table.HeaderCell />
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {values.map((row, key) => {
                let errors = rowErrors[key] || false
                return (
                  <Fragment key={key}>
                    <Table.Row>
                      {inputs.map(({ type, placeholder, options = {} }, inputKey) => (
                        <Table.Cell key={inputKey}>
                          {type === 'select' ? (
                            <select onChange={e => this.changeValue(key, inputKey, e.target.value)}>
                              {Object.keys(options).map(value => (
                                <option value={value} key={value}>
                                  {options[value]}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input
                              type={type}
                              defaultValue={row[inputKey] || ''}
                              placeholder={placeholder}
                              onBlur={e => this.changeValue(key, inputKey, e.target.value)}
                            />
                          )}
                        </Table.Cell>
                      ))}
                      <Table.Cell>
                        <button
                          className="button-plain button-plain--red"
                          onClick={e => e.preventDefault() & this.removeRow(key)}>
                          <Icon name="trash" />
                        </button>
                      </Table.Cell>
                    </Table.Row>
                    {errors ? (
                      <Table.Row error>
                        {inputs.map(({ type, placeholder }, inputKey) => (
                          <Table.Cell key={inputKey}>{errors[inputKey] || ''}</Table.Cell>
                        ))}
                        <Table.Cell></Table.Cell>
                      </Table.Row>
                    ) : null}
                  </Fragment>
                )
              })}
            </Table.Body>
          </Table>
        </Group>
        <div className="form-buttons" style={{ paddingTop: 0 }}>
          <button className="button-plain" onClick={e => e.preventDefault() & this.addRows(1)}>
            Lisää rivi
          </button>
          <button className="button-plain" onClick={e => e.preventDefault() & this.addRows(5)}>
            Lisää 5 riviä
          </button>
        </div>
      </div>
    )
  }
}
